import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const HomeCarIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: "33",
    height: "33",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M7.0995 14.324L5.99406 14.0606C5.50778 13.9455 5.15439 13.4309 5.15439 12.8379V12.3268C5.15439 11.9518 5.29312 11.5995 5.53699 11.3623C5.78086 11.125 6.09628 11.0291 6.4044 11.1041L8.24438 11.5437L8.13048 12.2274L6.2905 11.7878C6.15323 11.7547 6.0145 11.7966 5.9079 11.9012C5.79984 12.0076 5.73851 12.1611 5.73851 12.3268V12.8379C5.73851 13.0995 5.8933 13.3263 6.10796 13.3769L7.21341 13.6402L7.0995 14.324Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M25.9699 14.3187L25.8546 13.635L26.9323 13.3769C27.1469 13.3263 27.3017 13.0995 27.3017 12.8379V12.3268C27.3017 12.1611 27.2404 12.0076 27.1338 11.9012C27.0272 11.7966 26.887 11.7547 26.7512 11.7878L24.9799 12.2117L24.8645 11.528L26.6358 11.1041C26.944 11.0291 27.2609 11.125 27.5033 11.3623C27.7457 11.5995 27.8859 11.9518 27.8859 12.3268V12.8379C27.8859 13.4309 27.5325 13.9455 27.0462 14.0606L25.9699 14.3187Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M25.5371 13.9861L23.0298 8.16378C22.783 7.57423 22.2909 7.20968 21.7418 7.20968H11.2729C10.7253 7.20968 10.2317 7.57423 9.98641 8.1603L7.59153 13.8396L7.11255 13.5518L9.50744 7.87424C9.84331 7.07189 10.5209 6.57129 11.2729 6.57129H21.7418C22.4939 6.57129 23.1714 7.07014 23.5073 7.87424L26.0132 13.693L25.5371 13.9861Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M8.90988 26.4275H7.09911C6.31931 26.4275 5.68408 25.6688 5.68408 24.7373V23.6367H10.3249V24.7373C10.3249 25.6688 9.68968 26.4275 8.90988 26.4275ZM6.2682 24.3344V24.7373C6.2682 25.285 6.64058 25.7298 7.09911 25.7298H8.90988C9.36841 25.7298 9.74079 25.285 9.74079 24.7373V24.3344H6.2682Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M25.885 26.4275H24.0801C23.3003 26.4275 22.6665 25.6705 22.6665 24.7391V23.6367H27.2986V24.7391C27.2986 25.6705 26.6648 26.4275 25.885 26.4275ZM23.2506 24.3344V24.7391C23.2506 25.285 23.623 25.7298 24.0801 25.7298H25.885C26.3421 25.7298 26.7144 25.285 26.7144 24.7391V24.3344H23.2506Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M26.9244 24.335H6.07715C5.20681 24.335 4.50003 23.4908 4.50003 22.4513V18.1447C4.50003 15.4028 6.36775 13.1719 8.66334 13.1719H24.3367C26.6323 13.1719 28.5 15.4028 28.5 18.1447V22.4513C28.5015 22.9536 28.3379 23.4263 28.04 23.7821C27.7421 24.1379 27.3464 24.335 26.9244 24.335ZM8.66334 13.8696C6.69048 13.8696 5.08415 15.7865 5.08415 18.1447V22.4513C5.08415 23.1053 5.52954 23.6373 6.07715 23.6373H26.9244C27.1901 23.6373 27.4398 23.5135 27.6268 23.2902C27.8137 23.067 27.9159 22.7687 27.9159 22.453V18.1447C27.9159 15.7865 26.3096 13.8696 24.3367 13.8696H8.66334Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M25.6686 19.0865C24.8099 19.0865 23.8111 19.0865 22.9744 19.0865C22.1376 19.0865 22.3902 17.6649 22.9744 17.4173C23.5585 17.1696 25.0027 16.5469 25.6686 16.5469C26.3345 16.5469 26.7843 19.0865 25.6686 19.0865Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.36991 19.0533C8.22564 19.0533 9.22156 19.0533 10.0554 19.0533C10.8892 19.0533 10.6381 17.6317 10.0554 17.384C9.47274 17.1346 8.03434 16.5137 7.36991 16.5137C6.70547 16.5137 6.25716 19.0533 7.36991 19.0533Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }));
};
export default HomeCarIcon;